import { render } from "./InstructorLogbook.vue?vue&type=template&id=0ad72c87&scoped=true"
import script from "./InstructorLogbook.vue?vue&type=script&lang=js"
export * from "./InstructorLogbook.vue?vue&type=script&lang=js"

import "./InstructorLogbook.vue?vue&type=style&index=0&id=0ad72c87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad72c87"]])

export default __exports__